// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"80e59240","512":"3d492524"}[chunkId] + ".chunk.css";
};